import React from "react";
import { useRef, useEffect, useState } from "react";

export default function Tree({ tree, nodeSize = 30, zoomTree, setZoomTree, offsetTree, setOffsetTree }) {

    const treeContainerRef = useRef(null);
        let width = 0;
        let height = 0;


// Compute current SVG dimensions at the active zoom
const svgWidth = width * zoomTree;
const svgHeight = height * zoomTree;

// Legend layout constants
const legendPadding = 10;         // inner padding for the legend box
const legendCircleR = 8;          // circle radius
const legendCircleGap = 22;       // vertical gap between circles
const legendMargin = 12;          // margin from top-right edge
const legendFontSize = 12;
const legendTextGap = 8; // gap between circle and text

const legendTextStartX = legendPadding + legendCircleR * 2 + legendTextGap;

const legendItems = [
  { color: 'white', stroke: '#9aa0a6', label: "inactive" }, // white with subtle stroke
  { color: 'orange' , label: "triggered" },
  { color: 'green' , label: "fulfilled" },
  { color: 'red'   , label: "violated" },
  { color: 'grey'  , label: "terminated" },
  { color: 'white', stripe: true, label: "deadend" }, // white with subtle stroke
];

// Legend box size (only circles; no labels)
const legendRows = legendItems.length;

// Estimate text width by character count (approx 7px per character at 12px font)
const pxPerChar = 7;
const longestLabelLen = Math.max(...legendItems.map((li) => li.label.length));
const estimatedTextWidth = longestLabelLen * pxPerChar;


const legendBoxWidth = legendTextStartX + estimatedTextWidth + legendPadding;
const legendBoxHeight = legendPadding * 2 + legendRows * legendCircleGap;


// Top-right position inside the SVG space
const legendX = offsetTree.x + svgWidth - legendBoxWidth - legendMargin;
const legendY = offsetTree.y + legendMargin;


  useEffect(() => {
      updateTreeOffset(treeContainerRef.current, tree, width, height, zoomTree, offsetTree, setOffsetTree)
  }, [tree, zoomTree]);

    const handleZoomIn = () => {
        setZoomTree((z) => z * 1.2);
    }
    const handleZoomOut = () => {
        setZoomTree((z) => z / 1.2);
    }

  // helper to find a node by ID
  const findNode = (id) => tree.nodes.find(n => n.id === id);

    if (!tree) return <p></p>;


  const nodes = tree.nodes
  if (!nodes || nodes.length === 0) {
  width= 0
  height= 0 }

  else{
    const xValues = nodes.map(node => node.x);
    const yValues = nodes.map(node => node.y);

    const minX = Math.min(...xValues);
    const maxX = Math.max(...xValues);
    const minY = Math.min(...yValues);
    const maxY = Math.max(...yValues);

    width = maxX - minX + nodeSize * 2;
    height = maxY - minY + nodeSize * 2;
  }


  return (
  <div>
  <div
            ref={treeContainerRef}
    style={{
      width: "100%",
      height: "97vh",       // or whatever fixed height you want
      overflow: "scroll",      // enables scrollbars
      border: "1px solid #ccc",
    }}
  >

    <svg
    width={width*zoomTree + "px"}
            height={height*zoomTree + "px"}
            viewBox={`${-nodeSize} ${-nodeSize} ${width+nodeSize} ${height+nodeSize}`}
            style={{
                                  display: "block",
                                  transform: `translate(${offsetTree.x}px, ${offsetTree.y}px)`,
                                }}
    >
      {/* Define arrowhead marker once */}
      <defs>
        <marker
          id="arrow"
          markerWidth="10"
          markerHeight="10"
          refX="5"
          refY="5"
          orient="auto"
          markerUnits="strokeWidth"
        >
          <path d="M0,0 L10,5 L0,10 z" fill="black" />
        </marker>
      <pattern id="node-stripe" patternUnits="userSpaceOnUse" width="8" height="8">
        <rect width="10" height="10" fill="white" />
        <line x1="0" y1="0" x2="10" y2="10" stroke="black" strokeWidth="2.5" />
      </pattern>
      </defs>

      {/* Draw edges */}
      {tree.edges.map((e, i) => {
        const source = findNode(e.sourceId);
        const target = findNode(e.targetId);
        if (!source || !target) return null;

        return (
          <line
            key={i}
            x1={source.x}
            y1={source.y}
            x2={target.x}
            y2={target.y}
            stroke="black"
            strokeWidth={1}
            markerEnd="url(#arrow)"
          />
        );
      })}

      {/* Draw nodes */}
      {tree.nodes.map((n) => (
        <React.Fragment key={n.id}>
          <circle
            cx={n.x}
            cy={n.y}
            r={nodeSize / 2}
            fill={n.color === "stripe" ? "url(#node-stripe)" : n.color}
            stroke="black"
          />
          <text
            x={n.x}
            y={n.y + 4} // roughly center the text
            textAnchor="middle"
            fontSize="12"
            fill={n.color === "black" ? "white" : "black"} // contrast
          >
            {n.name}
          </text>
        </React.Fragment>
      ))}
    </svg>
<div
          style={{
            position: "absolute",
            bottom: "10px",
            left: "10px",
            background: "rgba(255,255,255,0.8)",
            padding: "5px",
            borderRadius: "5px",
            zIndex: 10,
            display: "flex",
            flexDirection: "column",
            gap: "5px",
          }}
        >
          <button onClick={handleZoomIn}>+</button>
          <button onClick={handleZoomOut}>-</button>
        </div>



{/* Legend overlay — pinned to top-left of the container */}
      <div
        style={{
          position: "absolute",
          top: "50px",
          left: "10px",
          background: "transparent",
          pointerEvents: "none", // overlay does not intercept clicks
        }}
      >
        <svg
          width={legendBoxWidth}
          height={legendBoxHeight}
          style={{ display: "block" }}
        >
        <defs>
          <pattern id="legend-stripe" patternUnits="userSpaceOnUse" width="4.5" height="4.5">
            <rect width="4.5" height="5" fill="transparent" />
            <line x1="0" y1="0" x2="4.5" y2="4.5" stroke="black" strokeWidth="1.5" />
          </pattern>
        </defs>
          <rect
            x={0}
            y={0}
            width={legendBoxWidth}
            height={legendBoxHeight}
            rx={6}
            fill="rgba(255,255,255,0.9)"
            stroke="#d0d7de"
          />
          {legendItems.map((item, i) => {
            const cy = legendPadding + legendCircleR + i * legendCircleGap;
            return (
              <g key={`legend-row-${i}`}>
                <circle
                  cx={legendPadding + legendCircleR}
                  cy={cy}
                  r={legendCircleR}
                    fill={item.stripe ? "url(#legend-stripe)" : item.color}
                  stroke={item.stroke || "none"}
                />
                <text
                  x={legendTextStartX}
                  y={cy}
                  fontSize={legendFontSize}
                  fill="#333"
                  dominantBaseline="middle"
                >
                  {item.label}
                </text>
              </g>
            );
          })}
        </svg>

                      </div>

                      </div>
    </div>

  );
}

export const updateTreeOffset = (container, tree, width, height, zoomTree, offsetTree, setOffsetTree)=>{
    if (!tree) return;

  if (!container){ // set off screen until ready to be fully rendered
          setOffsetTree({
            x: window.innerWidth,
            y: window.innerHeight,
          });
    return;
  }

    const containerWidth = container.clientWidth;
    const containerHeight = container.clientHeight;

    const svgWidth = width * zoomTree;
    const svgHeight = height * zoomTree;

    const newOffsetX = Math.max((containerWidth - svgWidth) / 2, 0)
    const newOffsetY = Math.max((containerHeight - svgHeight) / 2, 0)

    if (newOffsetX!=offsetTree.x || newOffsetY!=offsetTree.y){
    setOffsetTree({
      x: Math.max((containerWidth - svgWidth) / 2, 0),
      y: Math.max((containerHeight - svgHeight) / 2, 0),
    });
    }
}